import React, { ReactNode } from 'react';
import ReactDOM from 'react-dom';
import s from './Modal.module.css';
import close from '../../../assets/img/close.svg';
import arrow from '../../../assets/img/arrow_back.svg'
interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
    children: ReactNode;
    showHeader?: boolean;
    isArrowBack?:boolean;
    backFunction?: () => void;
    header?: string;
    width?:string;
    background?:string;
}

const Modal: React.FC<ModalProps> = ({ isOpen,
                                         onClose,
                                         children,
                                         showHeader = true,
                                         isArrowBack,
                                         backFunction,
                                         header,
                                         width,
                                         background
}) => {
    if (!isOpen) return null;

    const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return ReactDOM.createPortal(
        <div className={s.modalOverlay} onClick={handleOverlayClick}>
            <div className={s.modal} style={{ width,background }}>
                {showHeader && (
                    <div className={s.header}>
                        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                            {isArrowBack && <img src={arrow} onClick={backFunction} />}
                            {header}
                        </div>
                        <img src={close} alt="Close" onClick={onClose} />
                    </div>
                )}
                <div className={s.modalContent}>{children}</div>
            </div>
        </div>,
        document.getElementById('modal-root') || document.body
    );
};

export default Modal;
